import { Get, Post, Delete } from "../../utils/http-utils";

export const getDirectories = async () => {
    return Get("/scm/s3-file-browsing")
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return [];
        });
};

export const getFiles = async (queryParams = {}) => {
    return Get("/scm/s3-file-browsing", queryParams)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return [];
        });
};

export const getPresignedUrl = async (key) => {
    return Post("/scm/upload", key)
        .then((data) => data)
        .catch((err) => {
            console.error("Presigned URL error:", err);
            throw err;
        });
};

export const deleteFile = async (jsonPayload) => {
  return Delete("/scm/s3-delete", jsonPayload)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
}